import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_EXAM_SUMMARY} from '../../constants/apiUrls';
import {GET_NON_NATIONAL_EXAM_SUMMARY_QUERY_KEY} from '../../constants/queryKeys';
import {NonNationalExamSummaryResponse} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: NonNationalExamSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamSummary = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalExamSummary = async () => {
    const res = await axiosClient.get<NonNationalExamSummaryResponse>(
        GET_NON_NATIONAL_EXAM_SUMMARY(uuid)
    );
    return res.data;
  };
  return useCustomQuery([GET_NON_NATIONAL_EXAM_SUMMARY_QUERY_KEY], getNonNationalExamSummary, {
    onSuccess,
    onError,
  });
};
